import { z } from 'zod';
import { DiscriminatorSchema } from './guild.js';
export const ArenaOpponentGuildSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    discriminator: DiscriminatorSchema,
    frameId: z.string().min(1),
    logoUrl: z.string().nullable(),
    kind: z.literal('npc'),
});
export const ArenaHistoryEntrySchema = z.object({
    id: z.string(),
    /** Unix milliseconds. Legacy matches without a final receipt use first observation time. */
    endedAt: z.number().int().nonnegative(),
    winner: z.enum(['self', 'opponent', 'draw']),
    /** Won zones, not influence totals. */
    score: z.object({
        self: z.number().int().min(0).max(3),
        opponent: z.number().int().min(0).max(3),
    }),
    opponentGuild: ArenaOpponentGuildSchema.optional(),
});
export const ArenaHistoryResponseSchema = z.object({
    history: z.array(ArenaHistoryEntrySchema).max(20),
});
export const ArenaActionSchema = z.enum(['secret', 'discard', 'gift', 'split']);
export const ARENA_ACTION_SIZE = {
    secret: 1,
    discard: 1,
    gift: 3,
    split: 4,
};
export const ArenaCardSchema = z.object({
    id: z.string().min(1),
    characterId: z.string().min(1),
    universe: z.string().min(1),
    influence: z.number().int().min(1).max(4),
});
export const ArenaCommandSchema = z.discriminatedUnion('type', [
    z
        .object({
        type: z.literal('play'),
        action: ArenaActionSchema,
        cards: z.array(z.string().min(1)).min(1).max(4),
    })
        .strict(),
    z.object({ type: z.literal('choose'), index: z.number().int().min(0).max(2) }).strict(),
]);
const BoardCardSchema = z.discriminatedUnion('hidden', [
    z.object({ hidden: z.literal(true), slot: z.number().int() }),
    z.object({
        hidden: z.literal(false),
        slot: z.number().int(),
        card: ArenaCardSchema,
        secret: z.boolean(),
    }),
]);
const SideSchema = z.object({
    handCount: z.number().int(),
    deckCount: z.number().int(),
    used: z.array(ArenaActionSchema),
    board: z.array(BoardCardSchema).max(8),
});
export const ArenaViewSchema = z.object({
    id: z.string(),
    revision: z.number().int(),
    deadlineAt: z.number().nullable().optional(),
    serverNow: z.number().optional(),
    botThinking: z.boolean().optional(),
    finished: z.boolean(),
    yourTurn: z.boolean(),
    self: SideSchema.extend({ hand: z.array(ArenaCardSchema) }),
    opponent: SideSchema,
    opponentGuild: ArenaOpponentGuildSchema.optional(),
    zones: z
        .array(z.object({ universes: z.array(z.string()), self: z.number(), opponent: z.number() }))
        .min(1)
        .max(3),
    pending: z
        .object({
        action: z.enum(['gift', 'split']),
        yours: z.boolean(),
        options: z.array(z.array(ArenaCardSchema)),
    })
        .nullable(),
    winner: z.enum(['self', 'opponent', 'draw']).nullable(),
    events: z.array(z.string()),
});
export const ArenaResponseSchema = z.object({ match: ArenaViewSchema.nullable() });
export const ArenaStartSchema = z.object({ cards: z.array(z.string().min(1)).length(9) }).strict();
export const ArenaMoveSchema = z
    .object({
    matchId: z.string().uuid(),
    revision: z.number().int().nonnegative(),
    command: ArenaCommandSchema,
})
    .strict();
//# sourceMappingURL=arena.js.map